// extracted by mini-css-extract-plugin
export default {"loading":"photographySearch_loading__Afn17","pcWrap":"photographySearch_pcWrap__RmqIj"};